import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IItemDetailCombination, IStore, ITranslatableText } from './store.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { IAddress } from 'src/app/shared/services/address.service';
import { ICreditCard, IOrderItem } from './order.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { PageService } from 'src/app/services/page.service';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';

export interface IPreOrder {
  preOrderItems: IOrderItem[];
  note: string;
}

export interface IPlacePreOrderBase {
  storeId: string;
  terminalId: number;
  preOrder: IPreOrder;
  customerFirstName: string;
  customerLastName: string;
  customerName: string;
  customerEmail: string;
  phone: string;
  giftCard?: string;
  eCouponCode?: string;
  note: string;
  language: string;
  employeeId: number;
  tableAssigned: number;
  guestCount: number;
  orderTip: number;
  timeZone: string;
  orderDate: string;
  orderTime: string;
  estimatedTime?: string;
  _orderDate?: Date;
  _store?: IStore;
}

export interface IMemberPlacePreOrder extends IPlacePreOrderBase {
  cvn: number;
  savedCardId: string;
}

export interface IPlacePreOrder extends IPlacePreOrderBase {
  creditCard?: ICreditCard;
  billingAddress: IAddress;
}

@Injectable({
    providedIn: 'root'
})
export class PreOrderService {
  
  constructor(private http: HttpClient,
    private setting: SettingService,
    private auth: AuthService,
    private page: PageService,
  private apiController: ApiControllerService) { }

  placeOrder(preOrder: IPlacePreOrderBase): Observable<string> {
    return Observable.create(o => {
      //this.http.post(this.setting.apiUrl("PreOrder/PlacePreOrder"), preOrder, {
      this.apiController.post(this.setting.apiUrl("PreOrder/PlacePreOrder"), preOrder, {
          responseType: 'text'
      })
      .subscribe((data: string) => {
        o.next(data);
        o.complete();
      });
    });
  }

  memberPlaceOrder(order: IPlacePreOrderBase): Observable<string> {
    return Observable.create(o => {
      let headers = this.auth.getAuthHeadersBaseObject();
      this.page.appendAuthorizationHeader(headers);

      //this.http.post(this.setting.apiUrl('PreOrder/MemberPlacePreOrder'),
      this.apiController.post(this.setting.apiUrl('PreOrder/MemberPlacePreOrder'),
          order, { 
            headers: headers,
            responseType: 'text'
        })
      .subscribe((data: string) => {
          o.next(data);
          o.complete();
      } );               
    });
  }
}
